import { RecallType } from "../enums/recalls.enum";

const recallTypes = [RecallType.ER, RecallType.SC, RecallType.SR];
const recallNames = ['recall', 'campañas de servicio', 'campañas de servicio (recall)'];

export const isRecall = (type: string, name?: string): boolean => {
  const hasRecallName = recallNames.some(recallName => name?.toLowerCase().includes(recallName));
    return recallTypes.includes(type as RecallType) || hasRecallName;
};
export const isCSRecall = (type: string): boolean => type == RecallType.CS;
